
import { defineComponent, reactive, ref, onMounted, provide } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import ApiService from '@/core/services/ApiService'
import { ElMessage } from 'element-plus'
import InterfaceFilterSearchData from '@/assets/ts/_utils/models/FilterSearchData'
import { ElementAnimateUtil } from '@/assets/ts/_utils'

interface InterfaceSearchQueryObject {
  q: string
  count: number
}

export default defineComponent({
  name: 'SearchPopularQueriesList',
  setup() {
    const route = useRoute()
    const router = useRouter()

    const rowClasses = 'd-flex flex-column align-items-start justify-content-start'
    const searchQueryLoading = ref(false)
    const requestedSearchQueryList = ref<InterfaceSearchQueryObject[]>([])
    const paginationItemsNumber = ref(0)

    const filterData = reactive({
      page: 1,
      limit: 100
    } as InterfaceFilterSearchData)

    provide('filterData', filterData)

    /** Функция запроса данных */
    const requestSearchPopularQueries = () => {
      searchQueryLoading.value = true
      const params: InterfaceFilterSearchData = { ...filterData }

      ApiService.query('/admin/search/analytics/popular', { params })
          .then(response => {
            const data = response.data
            // Обновляем только total и items, page берем из filterData
            filterData.limit = data.limit
            paginationItemsNumber.value = data.total
            requestedSearchQueryList.value = data.items
            searchQueryLoading.value = false
          })
          .catch(() => {
            ElMessage.warning('Ошибка запроса поисковых запросов')
            searchQueryLoading.value = false
          })
    }

    /** Обновление URL при смене страницы */
    const updateUrlPage = (page: number) => {
      router.replace({ query: { ...route.query, page: page.toString() } })
    }

    /** Клик по пагинации */
    const paginationClick = (page: number) => {
      if (page === filterData.page) return
      filterData.page = page
      updateUrlPage(page)
      requestSearchPopularQueries()
      ElementAnimateUtil.scrollTop(0, 500)
    }

    /** При монтировании читаем страницу из query */
    onMounted(() => {
      const pageQuery = route.query.page
      const pageString = Array.isArray(pageQuery) ? pageQuery[0] : pageQuery
      const pageNumber = parseInt(pageString as string)
      filterData.page = pageNumber && pageNumber > 0 ? pageNumber : 1
      requestSearchPopularQueries()
    })

    return {
      rowClasses,
      searchQueryLoading,
      requestedSearchQueryList,
      filterData,
      paginationItemsNumber,
      paginationClick
    }
  }
})
